import Reflux from 'reflux';
import basketAPI from '../api/basket';
// import embeddedCheckout from '../utils/embeddedCheckout';

const api = {
  basket: basketAPI
};

const actions = Reflux.createActions({
  toggleShowTickets: {},
  prepareToBuy: {},
  buyTicket: { children: ['success', 'error'] },
  dismissError: {},
  hideRecaptcha: {},
  showRecaptcha: {},
  unlockPriceType: { children: ['success', 'error'] },
  clearUnlockPriceTypePasswordErrors: {},
  resetGASectionTicketQuantity: {},
  updateGASectionTicketQuantity: {},

  updateGASection: {},
  decreaseGASection: {},
  updateSeatPrice: {},
  resetSelectSeatAttempt: {},
  priceTypeToUnassignedSeat: {},
  dismissSingleSeatModal: {},
  goToBestAvailable: {}
});

actions.buyTicket.listen(basket => {
  api.basket.buyTicket(basket, (err, resp) => {
    if (resp && resp.url) {
      window.location.href = resp.url;

      /*
      // MNXWEB-3665 fix - commented because it may be the cause of endless spinning
      // wheel that shows after clicking ISM Buy button on *real* mobile device.
      if (embeddedCheckout.isEnabled()) {

        let onbeforeunload = function () {
          setTimeout(function () {
            window.removeEventListener('beforeunload', onbeforeunload);
            window.location.href = resp.url;
          }, 50);
        };

        window.addEventListener('beforeunload', onbeforeunload);
        embeddedCheckout.collapseFullScreen();
      }
      else {
        window.location.href = resp.url;
      }
      */
    }
    else {
      actions.buyTicket.error(err, resp);
    }
  });
});

actions.unlockPriceType.listen(payload => {
  api.basket.unlockPriceType(payload, (resp = {}) => {
    resp.priceTypeId = payload.priceTypeId;
    resp.valid
      ? actions.unlockPriceType.success(resp)
      : actions.unlockPriceType.error(resp);
  });
});

export default  actions;



// WEBPACK FOOTER //
// ./frontend/react/actions/basket.js